import { MantineTheme, createStyles } from "@mantine/core";

export const useStyles = createStyles((theme: MantineTheme) => ({
  valueContainer: {
    padding: "44px",
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    maxHeight: "750px",
  },
}));
